import { colors, text, radius } from '../design/tokens'

/**
 * Botón único del sistema — MISMA acción, MISMO botón en toda la app.
 *
 * Mapa semántico (ver skill estilos-lgr):
 *   primary     → "+ Nuevo", "Crear", "Guardar", acción principal de la página
 *   secondary   → "Editar", "Ver", acciones neutras
 *   ghost       → "Cancelar", "Volver", "Limpiar"
 *   destructive → "Eliminar", "Anular", "Rechazar"
 *   success     → "✓ Confirmar", "Entregado"
 *   send        → "→ Enviar a Presea", envíos/encolados
 *
 * <Boton variante="primary" sm onClick={...}>+ Nuevo</Boton>
 */
export const VARIANTES = {
  // primary AZUL sólido — decisión del usuario 6 jun 2026 (token colors.primary)
  primary:     { background: colors.primary, color: '#ffffff', border: `1px solid ${colors.primary}` },
  secondary:   { background: colors.bg, color: colors.textStrong, border: `1px solid ${colors.textPlh}` },
  ghost:       { background: colors.bg, color: '#475569', border: `1px solid ${colors.border}` },
  // Regla de Martin (16 ago 2026): NADA de rojo en botones — ni texto ni
  // fondo. La acción peligrosa se distingue con oscuro sólido; el peso lo
  // pone la confirmación (modal/confirm), no el color.
  destructive: { background: '#334155', color: '#fff', border: '1px solid #334155' },
  success:     { background: colors.okBg, color: colors.ok, border: '1px solid #bbf7d0' },
  send:        { background: colors.linkBg, color: colors.link, border: `1px solid ${colors.linkBorder}` },
}

export default function Boton({ variante = 'secondary', sm = false, style = {}, children, ...props }) {
  return (
    <button
      {...props}
      style={{
        ...VARIANTES[variante],
        padding: sm ? '4px 12px' : '0.45rem 1rem',
        borderRadius: radius.sm,
        cursor: props.disabled ? 'not-allowed' : 'pointer',
        fontSize: sm ? text.sec : 13,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        opacity: props.disabled ? 0.55 : 1,
        ...style,
      }}
    >
      {children}
    </button>
  )
}
